webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(474),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_HomePage__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AboutPage__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AboutPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_AboutPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_security_LoginPage__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_security_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_security_LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_security_ChangePasswordPage__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_security_ChangePasswordPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_security_ChangePasswordPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_dashboard_DashboardPage__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_dashboard_DashboardPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_dashboard_DashboardPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_dashboard_CustomDashboardPage__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_dashboard_CustomDashboardPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_dashboard_CustomDashboardPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_dashboard_ClassicDashboardPage__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_dashboard_ClassicDashboardPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_dashboard_ClassicDashboardPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_dashboard_ServerDashboardPage__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_dashboard_ServerDashboardPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_dashboard_ServerDashboardPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_servers_ServersPage__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_servers_ServersPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_servers_ServersPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_servers_AddServerPage__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_servers_AddServerPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_servers_AddServerPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_servers_ServerDetailsPage__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_servers_ServerDetailsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_servers_ServerDetailsPage__);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/**
 * By default the page are public, to secure a page, add the secure property with a value of true as part of the meta property
 *
 * meta: {
 *   secure: false
 * }
 */
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_HomePage___default.a
  }, {
    path: '/about',
    name: 'AboutPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_AboutPage___default.a
  }, {
    path: '/login',
    name: 'LoginPage',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_security_LoginPage___default.a
  }, {
    path: '/user/password',
    name: 'ChangePasswordPage',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_security_ChangePasswordPage___default.a
  }, {
    path: '/dashboard',
    name: 'DashboardPage',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_dashboard_DashboardPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/dashboard/classic',
    name: 'ClassicDashboardPage',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_dashboard_ClassicDashboardPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/dashboard/custom',
    name: 'CustomDashboardPage',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_dashboard_CustomDashboardPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/dashboard/:serverId',
    name: 'ServerDashboardPage',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dashboard_ServerDashboardPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/servers',
    name: 'ServersPage',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_servers_ServersPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/servers/add',
    name: 'AddServerPage',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_servers_AddServerPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/servers/:serverId',
    name: 'ServerDetailsPage',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_servers_ServerDetailsPage___default.a,
    meta: {
      secure: true
    }
  }]
}));

/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(2149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf705dca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2126:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(2138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0df8a38a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2127:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(2145),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-633b5de6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2128:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(2141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38f75866",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2129:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(2150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e52d6c2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2130:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(2144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-530270a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2131:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(2143),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52efb299",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2132:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(2140),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e9cab16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2133:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(577)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(2146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7018cd9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2134:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(2151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e59ea270",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2135:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(2139),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d3be985",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2136:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(2152),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6cbd880",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2137:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(2142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-467d9651",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('line-chart', {
    ref: "cpuTrendChart",
    attrs: {
      "chartData": _vm.cpu.trend.chartData,
      "options": _vm.cpu.trend.chartOptions
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 2139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Servers",
      "to": "/servers"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "New Server",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', [_c('b-row', [_c('b-col', [_c('b-form', {
    on: {
      "submit": _vm.addServer
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "name-group",
      "label": "Name:",
      "label-for": "name",
      "description": "Enter the name of the server"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter server name"
    },
    model: {
      value: (_vm.server.name),
      callback: function($$v) {
        _vm.$set(_vm.server, "name", $$v)
      },
      expression: "server.name"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "color-group",
      "label": "Color:",
      "label-for": "color",
      "description": "Color for display"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "color",
      "type": "color",
      "required": "",
      "placeholder": "Select color"
    },
    model: {
      value: (_vm.server.color),
      callback: function($$v) {
        _vm.$set(_vm.server, "color", $$v)
      },
      expression: "server.color"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "hostname-group",
      "label": "Hostname:",
      "label-for": "hostname",
      "description": "Server Hostname or IP Address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "hostname",
      "type": "text",
      "required": "",
      "placeholder": "Enter server hostname or IP address"
    },
    model: {
      value: (_vm.server.hostname),
      callback: function($$v) {
        _vm.$set(_vm.server, "hostname", $$v)
      },
      expression: "server.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "port-group",
      "label": "Port:",
      "label-for": "port",
      "description": "Server Port (default 4444)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "port",
      "type": "text",
      "required": "",
      "placeholder": "Enter server port"
    },
    model: {
      value: (_vm.server.port),
      callback: function($$v) {
        _vm.$set(_vm.server, "port", $$v)
      },
      expression: "server.port"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Group:",
      "label-for": "name",
      "description": "Enter the server group"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter server group"
    },
    model: {
      value: (_vm.server.group),
      callback: function($$v) {
        _vm.$set(_vm.server, "group", $$v)
      },
      expression: "server.group"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "description-group",
      "label": "Description:",
      "label-for": "description",
      "description": "Server Description"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Enter Description",
      "rows": "5"
    },
    model: {
      value: (_vm.server.description),
      callback: function($$v) {
        _vm.$set(_vm.server, "description", $$v)
      },
      expression: "server.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "type": "Submit",
      "variant": "primary"
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.metrics !== null) ? _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard",
      "to": "/dashboard"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": _vm.metrics.server.name,
      "active": true
    }
  })], 1), _vm._v(" "), (_vm.metrics !== null) ? _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('collapsible-card', {
    attrs: {
      "title": "Server Info",
      "visible": true
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.metrics.server.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hostname")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.metrics.server.hostname))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Group")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.metrics.server.group))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Free")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Used")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("CPU")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.metrics.current.cpu.idle)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.metrics.current.cpu.usage)))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RAM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.memory.free)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.memory.used)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.memory.free + _vm.metrics.current.memory.used)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Swap")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.swap.free)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.swap.used)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.swap.free + _vm.metrics.current.swap.used)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Disk")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.disk.free)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.disk.used)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("size")(_vm.metrics.current.disk.free + _vm.metrics.current.disk.used)))])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "header-tag": "header",
      "footer-tag": "footer"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Server Status")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "server",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2645026208)
  }, [_vm._v(" "), _c('b-card-text', [_c('bar-chart', {
    ref: "summaryChart",
    attrs: {
      "chartData": _vm.summary.chartData,
      "options": _vm.summary.chartOptions,
      "height": 375
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "header-tag": "header",
      "footer-tag": "footer"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("CPU")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "microchip",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2159769082)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "cpuPieChart",
    attrs: {
      "chartData": _vm.cpu.pie.chartData,
      "options": _vm.cpu.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("CPU Trend")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "microchip",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 3667682035)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "cpuTrendChart",
    attrs: {
      "chartData": _vm.cpu.trend.chartData,
      "options": _vm.cpu.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 1372592084)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "memoryPieChart",
    attrs: {
      "chartData": _vm.memory.pie.chartData,
      "options": _vm.memory.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 1372592084)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "memoryTrendChart",
    attrs: {
      "chartData": _vm.memory.trend.chartData,
      "options": _vm.memory.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    ref: "memory",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 90687552)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "swapPieChart",
    attrs: {
      "chartData": _vm.swap.pie.chartData,
      "options": _vm.swap.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 90687552)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "swapTrendChart",
    attrs: {
      "chartData": _vm.swap.trend.chartData,
      "options": _vm.swap.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "3",
      "md": "3",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2122568809)
  }, [_vm._v(" "), _c('b-card-text', [_c('doughnut-chart', {
    ref: "disksPieChart",
    attrs: {
      "chartData": _vm.disks.pie.chartData,
      "options": _vm.disks.pie.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "9",
      "md": "9",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2122568809)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "disksTrendChart",
    attrs: {
      "chartData": _vm.disks.trend.chartData,
      "options": _vm.disks.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2356794756)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "disksActivityTrendChart",
    attrs: {
      "chartData": _vm.disks.activity.chartData,
      "options": _vm.disks.activity.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Network Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "network-wired",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 2230381369)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "networkTrendChart",
    attrs: {
      "chartData": _vm.network.chartData,
      "options": _vm.network.chartOptions
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 2141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container'"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Hawkeye Server Monitoring")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Teedrei Inc")]), _vm._v(" "), _c('p', [_vm._v("Developed By: "), _c('a', {
    attrs: {
      "href": "https://edwardbiton.teedrei.com"
    }
  }, [_vm._v("Edward Biton")])])])])])])
}]}

/***/ }),

/***/ 2142:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Servers",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "owner-group"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Type to Search"
    },
    on: {
      "input": function($event) {
        return _vm.pageChange()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "to": "/servers/add"
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "display-mode",
      "options": _vm.displayModeOptions,
      "buttons": "",
      "button-variant": "outline-primary",
      "name": "display-mode"
    },
    model: {
      value: (_vm.displayMode),
      callback: function($$v) {
        _vm.displayMode = $$v
      },
      expression: "displayMode"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.displayMode === 'table') ? _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Group")]), _vm._v(" "), _c('th', [_vm._v("Hostname")]), _vm._v(" "), _c('th', [_vm._v("RAM")]), _vm._v(" "), _c('th', [_vm._v("Disk")]), _vm._v(" "), _c('th', [_vm._v("Color")]), _vm._v(" "), _c('th', [_vm._v("Visible")]), _vm._v(" "), _c('th', [_vm._v("Enabled")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.viewServer(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.hostname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("size")(item.metrics.memory.free)) + " / " + _vm._s(_vm._f("size")(item.metrics.memory.free + item.metrics.memory.used)) + " (" + _vm._s(_vm._f("percentage")(item.metrics.memory.usage)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("size")(item.metrics.disk.free)) + " / " + _vm._s(_vm._f("size")(item.metrics.disk.free + item.metrics.disk.used)) + " (" + _vm._s(_vm._f("percentage")(item.metrics.disk.usage)) + ")")]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "color",
        "readonly": true,
        "disabled": true
      },
      model: {
        value: (item.color),
        callback: function($$v) {
          _vm.$set(item, "color", $$v)
        },
        expression: "item.color"
      }
    })], 1), _vm._v(" "), _c('td', [(item.visible == true) ? _c('icon', {
      attrs: {
        "name": "eye"
      }
    }) : _vm._e(), _vm._v(" "), (item.visible == false) ? _c('icon', {
      attrs: {
        "name": "eye-slash"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.enabled == true) ? _c('icon', {
      attrs: {
        "name": "check"
      }
    }) : _vm._e(), _vm._v(" "), (item.enabled == false) ? _c('icon', {
      attrs: {
        "name": "ban"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": item.status === 'RUNNING' ? 'success' : ''
      }
    }, [_vm._v(_vm._s(item.status))])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_c('b-button-toolbar', [_c('b-button-group', [(item.visible == false) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Show"
      },
      on: {
        "click": function($event) {
          return _vm.setVisible(item.id, true)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "eye"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.visible == true) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Hide"
      },
      on: {
        "click": function($event) {
          return _vm.setVisible(item.id, false)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "eye-slash"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.enabled == false) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Enable"
      },
      on: {
        "click": function($event) {
          return _vm.setEnable(item.id, true)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.enabled == true) ? _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Disable"
      },
      on: {
        "click": function($event) {
          return _vm.setEnable(item.id, false)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "ban"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "disabled": item.enabled == false,
        "title": "Start"
      },
      on: {
        "click": function($event) {
          return _vm.startMonitor(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "play"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "disabled": item.enabled == false,
        "title": "Stop"
      },
      on: {
        "click": function($event) {
          return _vm.stopMonitor(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "stop"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Refresh"
      },
      on: {
        "click": function($event) {
          return _vm.refreshServer(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "sync"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteServer(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "#777"
      },
      attrs: {
        "name": "trash"
      }
    })], 1)], 1)], 1)], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'list') ? _c('b-list-group', _vm._l((_vm.items), function(item) {
    return _c('b-list-group-item', {
      on: {
        "click": function($event) {
          return _vm.viewServer(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('h5', {
      staticClass: "mb-1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('small', [(item.visible == true) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "eye",
        "title": "Visible"
      }
    }) : _vm._e(), _vm._v(" "), (item.visible == false) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "eye-slash",
        "title": "Hidden"
      }
    }) : _vm._e(), _vm._v(" "), (item.enabled == true) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "check",
        "title": "Enabled"
      }
    }) : _vm._e(), _vm._v(" "), (item.enabled == false) ? _c('icon', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "name": "ban",
        "title": "Disabled"
      }
    }) : _vm._e(), _vm._v(" "), _c('b-badge', {
      attrs: {
        "variant": item.status === 'RUNNING' ? 'success' : ''
      }
    }, [_vm._v(_vm._s(item.status))])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "mb-1"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.description) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "float-right"
    }, [_c('b-button-toolbar', [_c('b-button-group', [_c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "variant": "outline",
        "size": "sm",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteServer(item.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash"
      }
    })], 1)], 1)], 1)], 1)])
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row mt-3"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.totalItems) + " Servers")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.totalItems,
      "per-page": _vm.rowsPerPage
    },
    on: {
      "input": function($event) {
        return _vm.pageChange()
      }
    },
    model: {
      value: (_vm.pageNo),
      callback: function($$v) {
        _vm.pageNo = $$v
      },
      expression: "pageNo"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-form-select', {
    attrs: {
      "options": [{
        text: 10,
        value: 10
      }, {
        text: 25,
        value: 25
      }, {
        text: 50,
        value: 50
      }, {
        text: 100,
        value: 100
      }]
    },
    on: {
      "input": function($event) {
        return _vm.pageChange()
      }
    },
    model: {
      value: (_vm.rowsPerPage),
      callback: function($$v) {
        _vm.rowsPerPage = $$v
      },
      expression: "rowsPerPage"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard",
      "active": true
    }
  })], 1), _vm._v(" "), (_vm.metrics !== null) ? _c('b-container', {
    ref: "container",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "12",
      "md": "12",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('collapsible-card', {
    attrs: {
      "title": "Server Info",
      "visible": true
    }
  }, [_c('b-row', {
    staticClass: "p-2"
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Group:",
      "label-for": "group",
      "description": "Select the server group to display"
    }
  }, [(_vm.groupOptions !== null) ? _c('b-input-group', [_c('b-form-select', {
    attrs: {
      "placeholder": "Select Group",
      "options": _vm.groupOptions
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Display Mode:",
      "label-for": "displayMode",
      "description": ""
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "display-mode",
      "options": _vm.displayModeOptions,
      "buttons": "",
      "button-variant": "outline-primary",
      "name": "display-mode"
    },
    model: {
      value: (_vm.displayMode),
      callback: function($$v) {
        _vm.displayMode = $$v
      },
      expression: "displayMode"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Full:",
      "label-for": "full",
      "description": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fullScreen()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrows-alt"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card-text', {
    staticStyle: {
      "overflow": "auto",
      "height": "440px"
    }
  }, [(_vm.displayMode === 'bar') ? _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Server")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("CPU")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Memory")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Swap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Disk")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.metrics), function(item) {
    return (_vm.isMatchGroup(item.server)) ? _c('tr', [_c('td', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(item.server.id)
        }
      }
    }, [_c('span', {
      style: ('cursor:pointer; color: ' + item.server.color)
    }, [_vm._v(_vm._s(item.server.name))]), _vm._v(" "), (_vm.isVisible(item.server)) ? _c('span', {
      staticClass: "float-right"
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.cpu.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.memory.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.swap.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-progress', {
      attrs: {
        "value": item.current.disk.usage,
        "max": 100,
        "height": "2rem",
        "animated": ""
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, true)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, false)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye-slash"
      }
    })], 1)], 1)]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'text') ? _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Server")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("CPU")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("Memory")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("Swap")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%",
      "colspan": "3"
    }
  }, [_vm._v("Disk")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("System")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Used")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Used")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Used")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.metrics), function(item) {
    return (_vm.isMatchGroup(item.server)) ? _c('tr', [_c('td', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(item.server.id)
        }
      }
    }, [_c('span', {
      style: ('cursor:pointer; color: ' + item.server.color)
    }, [_vm._v(_vm._s(item.server.name))]), _vm._v(" "), (_vm.isVisible(item.server)) ? _c('span', {
      staticClass: "float-right"
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")(item.current.cpu.user)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")(item.current.cpu.system)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("percentage")(item.current.cpu.usage)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.memory.free)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.memory.used)) + " (" + _vm._s(_vm._f("percentage")(item.current.memory.usage)) + ")")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.memory.free + item.current.memory.used)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.swap.free)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.swap.used)) + " (" + _vm._s(_vm._f("percentage")(item.current.swap.usage)) + ")")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.swap.free + item.current.swap.used)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.disk.free)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.disk.used)) + " (" + _vm._s(_vm._f("percentage")(item.current.disk.usage)) + ")")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("size")(item.current.disk.free + item.current.disk.used)))]), _vm._v(" "), _c('td', [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, true)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye"
      }
    })], 1), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          return _vm.setVisible(item.server, false)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "eye-slash"
      }
    })], 1)], 1)]) : _vm._e()
  })], 2)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("CPU Trend")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "microchip",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 3667682035)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "cpuTrendChart",
    attrs: {
      "chartData": _vm.cpu.trend.chartData,
      "options": _vm.cpu.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 1372592084)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "memoryTrendChart",
    attrs: {
      "chartData": _vm.memory.trend.chartData,
      "options": _vm.memory.trend.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Disk Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "hdd",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n\t\t\t\t\t\tGraph going up is bytes read, graph going down is bytes written\n\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 111785203)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "disksActivityTrendChart",
    attrs: {
      "chartData": _vm.disks.activity.chartData,
      "options": _vm.disks.activity.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Network Activity")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "network-wired"
          }
        })], 1)], 1)]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n\t\t\t\t\t\tGraph going up is bytes received, graph going down is bytes sent\n\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 2580753639)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "networkTrendChart",
    attrs: {
      "chartData": _vm.network.chartData,
      "options": _vm.network.chartOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "9"
          }
        }, [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "3"
          }
        }, [_c('icon', {
          attrs: {
            "name": "memory",
            "scale": "1"
          }
        })], 1)], 1)]
      },
      proxy: true
    }], null, false, 90687552)
  }, [_vm._v(" "), _c('b-card-text', [_c('line-chart', {
    ref: "swapTrendChart",
    attrs: {
      "chartData": _vm.swap.trend.chartData,
      "options": _vm.swap.trend.chartOptions
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2144:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Custom",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    ref: "container",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('splitpanes', {
    staticClass: "default-theme",
    staticStyle: {
      "height": "750px"
    }
  }, [_c('pane', {
    attrs: {
      "size": "20",
      "min-size": "10",
      "max-size": "50"
    }
  }), _vm._v(" "), _c('pane', [_vm._l((_vm.chartConfigs), function(chartConfig) {
    return [_c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('b-card', {
      attrs: {
        "title": chartConfig.name,
        "visible": true
      }
    }, [_c('b-card-text', {
      staticStyle: {
        "overflow": "auto",
        "height": "700px"
      }
    }, [_c('cpu-chart', {
      attrs: {
        "config": chartConfig
      }
    })], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2145:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container'"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Hawkeye Server Monitoring")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Teedrei Inc")]), _vm._v(" "), _c('p', [_vm._v("Developed By: "), _c('a', {
    attrs: {
      "href": "https://edwardbiton.teedrei.com"
    }
  }, [_vm._v("Edward Biton")])])])])])])
}]}

/***/ }),

/***/ 2146:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "User Profile",
      "to": "/user/profile"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Password",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', [_c('b-form', {
    on: {
      "submit": _vm.changePassword
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "oldPassword-group",
      "label": "Current Password:",
      "label-for": "oldPassword",
      "description": "Enter your current password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "oldPassword",
      "type": "password",
      "autofocus": "",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "newPassword-group",
      "label": "New Password:",
      "label-for": "newPassword",
      "description": "Enter a new password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "newPassword",
      "type": "password",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "verifyPassword-group",
      "label": "Verify Password:",
      "label-for": "verifyPassword",
      "description": "Re-enter new password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "verifyPassword",
      "type": "password",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.verifyPassword),
      callback: function($$v) {
        _vm.verifyPassword = $$v
      },
      expression: "verifyPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "type": "Submit",
      "variant": "primary"
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "no-body": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('b-row', [_c('b-col', [_c('h4', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('b-col', {
          staticClass: "text-right"
        }, [_c('b-button', {
          class: !_vm.localVisible ? 'collapsed' : null,
          attrs: {
            "variant": "link",
            "aria-controls": "contentPanel",
            "aria-expanded": _vm.localVisible ? 'true' : 'false'
          },
          on: {
            "click": function($event) {
              _vm.localVisible = !_vm.localVisible
            }
          }
        }, [_c('icon', {
          attrs: {
            "name": _vm.localVisible ? 'chevron-down' : 'chevron-left'
          }
        })], 1)], 1)], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('b-card-body', {
    staticClass: "p-0"
  }, [_c('b-collapse', {
    attrs: {
      "id": "contentPanel"
    },
    model: {
      value: (_vm.localVisible),
      callback: function($$v) {
        _vm.localVisible = $$v
      },
      expression: "localVisible"
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2148:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "xl",
      "type": "dark",
      "variant": "dark",
      "sticky": "",
      "fixed": ""
    }
  }, [_c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(588),
      "height": "64"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.authenticationService.isAuthenticated()) ? _c('b-nav-item', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Dashboard")]) : _vm._e(), _vm._v(" "), (_vm.authenticationService.isAuthenticated()) ? _c('b-nav-item', {
    attrs: {
      "to": "/servers"
    }
  }, [_vm._v("Servers")]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.authenticationService.isAuthenticated() === false) ? _c('b-nav-item', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item-dropdown', {
    attrs: {
      "id": "user-dropdown",
      "text": _vm.user.displayName,
      "toggle-class": "nav-link-custom",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function() {
        return [_c('b-img', {
          attrs: {
            "src": _vm.user.imageUrl,
            "rounded": "circle",
            "width": "32"
          }
        }), _vm._v(" " + _vm._s(_vm.user.displayName) + "\r\n\t\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 2936113834)
  }, [_vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user/password"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")])], 1) : _vm._e(), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "id": "help-dropdown",
      "text": "Help",
      "toggle-class": "nav-link-custom",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "https://www.teedrei.com",
      "target": "new"
    }
  }, [_vm._v("Documentation")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.text === false) ? _c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": _vm.onVariant,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.setValue(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.on))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": _vm.offVariant,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.setValue(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.off))])], 1) : _c('span', [_vm._v(_vm._s(_vm.textValue))])
},staticRenderFns: []}

/***/ }),

/***/ 2150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('CollapsibleCard', {
    attrs: {
      "title": "Filters",
      "visible": false
    }
  }, [_c('b-row', {
    staticClass: "p-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "name-group",
      "label": "Group:",
      "label-for": "group",
      "description": "Select the server group to display"
    }
  }, [(_vm.groupOptions !== null) ? _c('b-input-group', [_c('b-form-select', {
    attrs: {
      "placeholder": "Select Group",
      "options": _vm.groupOptions
    },
    on: {
      "input": function($event) {
        return _vm.loadServers()
      }
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, _vm._l((_vm.servers), function(server) {
    return _c('span', [_c('span', {
      style: ('cursor:pointer; color:' + server.color)
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": server.visible ? 'Hide' : 'Show'
      },
      on: {
        "click": function($event) {
          return _vm.setVisible(server.id, !server.visible)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": server.visible ? 'eye' : 'eye-slash'
      }
    })], 1), _vm._v(" "), (server.visible) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(server.id)
        }
      }
    }, [_vm._v(_vm._s(server.name))]) : _vm._e(), _vm._v(" "), (!server.visible) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.viewServerDashboard(server.id)
        }
      }
    }, [_c('strike', [_vm._v(_vm._s(server.name))]), _vm._v(" ")], 1) : _vm._e()])])
  }), 0)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', {
    ref: "cpu"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("CPU")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    },
    on: {
      "click": function($event) {
        return _vm.fullscreenCpu()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "microchip",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.cpuChartData != null) ? _c('line-chart', {
    ref: "cpuChart",
    attrs: {
      "chartData": _vm.cpuChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Memory")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "memory",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.memoryChartData != null) ? _c('line-chart', {
    ref: "memoryChart",
    attrs: {
      "chartData": _vm.memoryChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Swap")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "memory",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.swapChartData != null) ? _c('line-chart', {
    ref: "swapChart",
    attrs: {
      "chartData": _vm.swapChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Disk")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "hdd",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.diskChartData != null) ? _c('line-chart', {
    ref: "diskChart",
    attrs: {
      "chartData": _vm.diskChartData,
      "options": _vm.relativeOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Disk Read")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "hdd",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.diskReadBytesChartData != null) ? _c('line-chart', {
    ref: "diskReadBytesChart",
    attrs: {
      "chartData": _vm.diskReadBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "4",
      "md": "4",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Disk Write")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "hdd",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.diskWriteBytesChartData != null) ? _c('line-chart', {
    ref: "diskWriteBytesChart",
    attrs: {
      "chartData": _vm.diskWriteBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Network Received")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "network-wired",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.networkReceivedBytesChartData != null) ? _c('line-chart', {
    ref: "networkReceivedBytesChart",
    attrs: {
      "chartData": _vm.networkReceivedBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "6",
      "xs": "12"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Network Sent")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('icon', {
    attrs: {
      "name": "network-wired",
      "scale": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.networkSentBytesChartData != null) ? _c('line-chart', {
    ref: "networkSentBytesChart",
    attrs: {
      "chartData": _vm.networkSentBytesChartData,
      "options": _vm.absoluteOptions,
      "height": 250
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2151:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "overflow-hidden",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-card-img', {
    staticClass: "rounded-0",
    attrs: {
      "src": "./static/images/login-background.jpg"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-card-body', {
    attrs: {
      "title": "Hawkeye"
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "username-group",
      "label": "Username:",
      "label-for": "username",
      "description": "Default user is admin"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "username",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "password-group",
      "label": "Password:",
      "label-for": "password",
      "description": "Default password is 123"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "required": "",
      "placeholder": "Enter password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2152:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.server !== null) ? _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Servers",
      "to": "/servers"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": _vm.server.name,
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', [_c('b-form', {
    on: {
      "submit": _vm.updateServer
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Details"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "name-group",
      "label": "Name:",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text"
    },
    model: {
      value: (_vm.server.name),
      callback: function($$v) {
        _vm.$set(_vm.server, "name", $$v)
      },
      expression: "server.name"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "color-group",
      "label": "Color:",
      "label-for": "color",
      "description": "Color for display"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "color",
      "type": "color",
      "required": "",
      "placeholder": "Select color"
    },
    model: {
      value: (_vm.server.color),
      callback: function($$v) {
        _vm.$set(_vm.server, "color", $$v)
      },
      expression: "server.color"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "hostname-group",
      "label": "Hostname:",
      "label-for": "hostname"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "hostname",
      "type": "text"
    },
    model: {
      value: (_vm.server.hostname),
      callback: function($$v) {
        _vm.$set(_vm.server, "hostname", $$v)
      },
      expression: "server.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "port-group",
      "label": "Port:",
      "label-for": "port"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "port",
      "type": "text"
    },
    model: {
      value: (_vm.server.port),
      callback: function($$v) {
        _vm.$set(_vm.server, "port", $$v)
      },
      expression: "server.port"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "group-group",
      "label": "Group:",
      "label-for": "name",
      "description": "Enter the server group"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "group",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter server group"
    },
    model: {
      value: (_vm.server.group),
      callback: function($$v) {
        _vm.$set(_vm.server, "group", $$v)
      },
      expression: "server.group"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "description-group",
      "label": "Description:",
      "label-for": "description"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "type": "text",
      "max-rows": "5",
      "rows": "5"
    },
    model: {
      value: (_vm.server.description),
      callback: function($$v) {
        _vm.$set(_vm.server, "description", $$v)
      },
      expression: "server.description"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "type": "Submit",
      "variant": "primary"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: '/',
  //  baseURL: 'http://localhost:8080/',
  //  baseURL: 'https://hawkeye.teedrei.com/',
  headers: {
    // Authorization: 'Basic ' + credentials
  }
});

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(476),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(478),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(2148),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_splitpanes__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_splitpanes_dist_splitpanes_css__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_splitpanes_dist_splitpanes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_splitpanes_dist_splitpanes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_AuthenticationService__ = __webpack_require__(58);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__["a" /* default */]);

var numeral = __webpack_require__(450);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value) {
  return numeral(value).format('0,0.00'); // displaying other groupings/separators is possible, look at the docs
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('percentage', function (value) {
  return numeral(value).format('0,0.00') + '%'; // displaying other groupings/separators is possible, look at the docs
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('integer', function (value) {
  return numeral(value).format('0,0'); // displaying other groupings/separators is possible, look at the docs
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('size', function (value) {
  var divisor = 1;
  var suffix = '';
  if (value > 1099511627776) {
    divisor = 1099511627776;
    suffix = 'tb';
  } else if (value > 1073741824) {
    divisor = 1073741824;
    suffix = 'gb';
  } else if (value > 1048576) {
    divisor = 1048576;
    suffix = ' mb';
  } else if (value > 1024) {
    divisor = 1024;
    suffix = ' kb';
  }
  return (value / divisor).toFixed(2) + suffix;
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$filters = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].options.filters;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('splitpanes', __WEBPACK_IMPORTED_MODULE_8_splitpanes__["a" /* Splitpanes */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('pane', __WEBPACK_IMPORTED_MODULE_8_splitpanes__["b" /* Pane */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});



/**
 * This code will check if the page is secure and redirect the user to the login page if the user have not logged-in
 */
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  console.log('router: ' + to.path + ' secure=' + to.meta.secure);
  if (to.meta.secure) {
    // console.log('router: page is secure, checking if user has authenticated')
    if (__WEBPACK_IMPORTED_MODULE_10__services_AuthenticationService__["a" /* authenticationService */].isAuthenticated() === false) {
      // console.log('router: User has not authenticated, redirecting to login page at /login')
      next('/login');
      return;
    }
  }
  next();
});

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    title: String,
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String,
    tabindex: [Number, String]
  },
  data: function data() {
    return {
      id: getId(),
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    },
    focusable: function focusable() {
      var tabindex = this.tabindex;

      if (tabindex == null) {
        return 'false';
      }
      var index = typeof tabindex === 'string' ? parseInt(tabindex, 10) : tabindex;
      if (index >= 0) {
        return null;
      }
      return 'false';
    }
  },
  mounted: function mounted() {
    this.updateStack();
  },
  updated: function updated() {
    this.updateStack();
  },

  methods: {
    updateStack: function updateStack() {
      var _this = this;

      if (!this.name && this.name !== null && this.$children.length === 0) {
        console.warn('Invalid prop: prop "name" is required.');
        return;
      }

      if (this.icon) {
        return;
      }

      var width = 0;
      var height = 0;
      this.$children.forEach(function (child) {
        child.outerScale = _this.normalizedScale;

        width = Math.max(width, child.width);
        height = Math.max(height, child.height);
      });
      this.childrenWidth = width;
      this.childrenHeight = height;
      this.$children.forEach(function (child) {
        child.x = (width - child.width) / 2;
        child.y = (height - child.height) / 2;
      });
    }
  },
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      class: this.klass,
      style: this.style,
      attrs: {
        role: this.$attrs.role || (this.label || this.title ? 'img' : null),
        'aria-label': this.label || null,
        'aria-hidden': String(!(this.label || this.title)),
        tabindex: this.tabindex,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box,
        focusable: this.focusable
      }
    };

    var titleId = 'vat-' + this.id;
    if (this.title) {
      options.attrs['aria-labelledby'] = titleId;
    }

    if (this.raw) {
      var html = this.raw;

      if (this.title) {
        html = '<title id="' + titleId + '">' + escapeHTML(this.title) + '</title>' + html;
      }

      options.domProps = {
        innerHTML: html
      };
    }

    var content = this.title ? [h('title', { attrs: { id: titleId } }, this.title)] : [];

    return h('svg', options, this.raw ? null : content.concat(this.$slots.default || [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: 'path-' + i
      });
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: 'polygon-' + i
      });
    })))));
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === undefined ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === undefined ? [] : _icon$polygons,
          points = icon.points;


      if (d) {
        paths.push({ d: d });
      }

      if (points) {
        polygons.push({ points: points });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },

  icons: icons
});

function assign(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
  });

  return obj;
}

var cursor = 0xd4937;
function getId() {
  return 'va-' + (cursor++).toString(16);
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};

function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(148);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      authenticationService: __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* authenticationService */]
    };
  },
  computed: {
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* authenticationService */].getUser();
    }
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* authenticationService */].logout();
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/login');
    }
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(147);



/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Bar */],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      localChartData: null
    };
  },
  methods: {
    updateChart: function updateChart() {
      this.$data._chart.update();
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    chartData: {
      handler: function handler() {
        this.renderChart(this.chartData, this.options);
      },
      deep: false
    }
  }
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localVisible: _this.visible
    };
  },
  mounted: function mounted() {
    this.localVisible = this.visible;
  }
});

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(147);



/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Doughnut */],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      localChartData: null
    };
  },
  methods: {
    updateChart: function updateChart() {
      this.$data._chart.update();
    }
  },
  mounted: function mounted() {
    this.addPlugin({
      id: 'my-plugin',
      beforeDraw: function beforeDraw(chart) {
        if (chart.config.data.text) {
          var text = chart.config.data.text;
          // Get ctx from string
          var ctx = chart.chart.ctx;

          // initialize default config
          var font = 'Arial';
          var color = '#000';
          var padding = 20;
          // Get options from the center object in options
          var textConfig = chart.config.options.text;
          if (textConfig !== undefined) {
            font = textConfig.font !== undefined ? textConfig.font : 'Arial';
            color = textConfig.color !== undefined ? textConfig.color : '#000';
            padding = textConfig.padding !== undefined ? textConfig.padding : 20;
          }
          var paddingCalculated = padding / 100 * (chart.innerRadius * 2);
          // Start with a base font of 30px
          ctx.font = '30px ' + font;

          // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(text).width;
          var elementWidth = chart.innerRadius * 2 - paddingCalculated;

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth;
          var newFontSize = Math.floor(30 * widthRatio);
          var elementHeight = chart.innerRadius * 2;

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight);

          // Set font settings to draw it correctly.
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = fontSizeToUse + 'px ' + font;
          ctx.fillStyle = color;

          // Draw text in center
          ctx.fillText(text, centerX, centerY);
        }
      }
    });
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    chartData: {
      handler: function handler() {
        // this.renderChart(this.chartData, this.options)
        console.log('Updating chart');
        this.$data._chart.update();
      },
      deep: false
    }
  }
});

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(147);



/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      localChartData: null
    };
  },
  methods: {
    updateChart: function updateChart() {
      this.$data._chart.update();
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    chartData: {
      handler: function handler() {
        this.renderChart(this.chartData, this.options);
      },
      deep: false
    }
  }
});

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _this = this;

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toggle',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: 'On'
    },
    off: {
      type: String,
      default: 'Off'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localValue: _this.value
    };
  },
  computed: {
    onVariant: function onVariant() {
      return this.value ? this.variant : 'outline-primary';
    },
    offVariant: function offVariant() {
      return this.value ? 'outline-primary' : this.variant;
    },
    textValue: function textValue() {
      return this.value ? this.on : this.off;
    }
  },
  methods: {
    setValue: function setValue(value) {
      this.localValue = value;
      this.$emit('input', this.localValue);
      this.$emit('change', this.localValue);
    }
  }
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_ColorService__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineChart_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LineChart_vue__);
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_2__LineChart_vue___default.a
  },
  name: 'cpu-chart',
  props: {
    config: Object
  },
  data: function data() {
    return {
      refreshInterval: null,
      cpu: {
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#9fcdff',
              borderColor: '#9fcdff',
              data: []
            }, {
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      }
    };
  },
  methods: {
    colorSeverity: function colorSeverity(color, value) {
      console.log(__WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(color, value / 100));
      return __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(color, value / 100);
    },
    loadFirstTime: function loadFirstTime() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('dashboard').then(function (response) {
        _this.metrics = response.data;
        _this.cpu.trend.chartData.datasets = [];
        for (var i in _this.metrics) {
          var server = _this.metrics[i];
          var labels = [];
          var cpuUsageTrend = [];
          for (var j in server.metrics) {
            var metric = server.metrics[j];
            labels.push('');
            cpuUsageTrend.push(metric.cpu.usage);
          }
          var dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: cpuUsageTrend
            // update cpu trend data
          };_this.cpu.trend.chartData.labels = labels;
          _this.cpu.trend.chartData.datasets.push(dataset);
        }
        _this.$refs.cpuTrendChart.updateChart();
      });
    },
    loadLatest: function loadLatest() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('metrics/metrics', {
        params: {
          serverIds: this.config.serverIds
        } }).then(function (response) {
        var serverMetrics = response.data;
        for (var i in serverMetrics) {
          var serverMetric = serverMetrics[i];
          var chartData = _this2.cpu.trend.chartData.datasets[i].data;
          // this.cpu.trend.chartData.labels.push('')
          chartData.shift();
          chartData.push(serverMetric.metric.cpu.usage);
        }
        _this2.$refs.cpuTrendChart.updateChart();
      });
    },
    fullScreen: function fullScreen() {
      this.$refs.container.webkitRequestFullscreen();
    }
  },
  created: function created() {
    this.loadFirstTime();
    console.log('first time...');
    this.refreshInterval = setInterval(this.loadLatest, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.refreshInterval);
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ToggleButton_vue__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ToggleButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ToggleButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LineChart_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ToggleButton: __WEBPACK_IMPORTED_MODULE_1__components_ToggleButton_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2__components_LineChart_vue___default.a,
    CollapsibleCard: __WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue___default.a
  },
  name: 'monitor',
  data: function data() {
    return {
      height: 250,
      group: '',
      groupOptions: null,
      servers: [],
      refreshInterval: null,
      cpuChartData: null,
      memoryChartData: null,
      swapChartData: null,
      diskChartData: null,
      diskReadBytesChartData: null,
      diskWriteBytesChartData: null,
      networkReceivedBytesChartData: null,
      networkSentBytesChartData: null,
      relativeOptions: {
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 100
            }
          }]
        }
      },
      absoluteOptions: {
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              callback: function callback(value, index, values) {
                // var max = Math.max.apply(null, values)
                var max = value;
                var divisor = 1;
                var suffix = '';
                if (max > 1048576) {
                  divisor = 1048576;
                  suffix = ' mb';
                } else if (max > 1024) {
                  divisor = 1024;
                  suffix = ' kb';
                }
                return (value / divisor).toFixed(2) + suffix;
              }
            },
            scaleLabel: {
              display: true,
              labelString: ''
            }
          }]
        }
      }
    };
  },
  methods: {
    loadGroups: function loadGroups() {
      this.groupOptions = [];
      this.groupOptions.push({
        value: '',
        text: 'All'
      });
      for (var i in this.servers) {
        var server = this.servers[i];
        var indexOf = this.groupOptions.map(function (element) {
          return element.text;
        }).indexOf(server.group);
        if (indexOf < 0) {
          var option = {
            value: server.group,
            text: server.group
          };
          this.groupOptions.push(option);
        }
      }
    },
    loadServers: function loadServers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('servers?group=' + this.group, {
        params: {
          page: 0,
          rowsPerPage: 1000
        }
      }).then(function (response) {
        _this.servers = response.data.list;
        if (_this.groupOptions === null) {
          _this.loadGroups();
        }
      });
    },
    toggleServer: function toggleServer(server) {
      server.visible = !server.visible;
    },
    updateData: function updateData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('metrics?group=' + this.group).then(function (response) {
        var charts = response.data;
        for (var i in charts.cpu.datasets) {
          charts.cpu.datasets[i].borderWidth = 1;
          charts.cpu.datasets[i].pointRadius = 1;
          charts.memory.datasets[i].borderWidth = 1;
          charts.memory.datasets[i].pointRadius = 1;
          charts.swap.datasets[i].borderWidth = 1;
          charts.swap.datasets[i].pointRadius = 1;
          charts.disk.datasets[i].borderWidth = 1;
          charts.disk.datasets[i].pointRadius = 1;
          charts.diskReadBytes.datasets[i].borderWidth = 1;
          charts.diskReadBytes.datasets[i].pointRadius = 1;
          charts.diskWriteBytes.datasets[i].borderWidth = 1;
          charts.diskWriteBytes.datasets[i].pointRadius = 1;
          charts.networkReceivedBytes.datasets[i].borderWidth = 1;
          charts.networkReceivedBytes.datasets[i].pointRadius = 1;
          charts.networkSentBytes.datasets[i].borderWidth = 1;
          charts.networkSentBytes.datasets[i].pointRadius = 1;
        }
        _this2.cpuChartData = charts.cpu;
        _this2.memoryChartData = charts.memory;
        _this2.swapChartData = charts.swap;
        _this2.diskChartData = charts.disk;
        _this2.diskReadBytesChartData = charts.diskReadBytes;
        _this2.diskWriteBytesChartData = charts.diskWriteBytes;
        _this2.networkReceivedBytesChartData = charts.networkReceivedBytes;
        _this2.networkSentBytesChartData = charts.networkSentBytes;
      });
    },
    setVisible: function setVisible(serverId, visible) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers/' + serverId + '/visible?visible=' + visible).then(function (response) {
        _this3.loadServers();
      });
    },
    viewServerDashboard: function viewServerDashboard(serverId) {
      this.$router.push({
        name: 'ServerDashboardPage',
        params: {
          serverId: serverId
        }
      });
    },
    fullscreenCpu: function fullscreenCpu() {
      this.$refs.cpu.webkitRequestFullscreen();
    }
  },
  created: function created() {
    this.loadServers();
    this.updateData();
    this.refreshInterval = setInterval(this.updateData, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.refreshInterval);
  }
});

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_ColorService__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_server_charts_CpuChart_vue__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_server_charts_CpuChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_server_charts_CpuChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CpuChart: __WEBPACK_IMPORTED_MODULE_2__components_server_charts_CpuChart_vue___default.a,
    CollapsibleCard: __WEBPACK_IMPORTED_MODULE_3__components_CollapsibleCard_vue___default.a
  },
  name: 'dashboard',
  data: function data() {
    return {
      servers: null,
      chartConfigs: []
    };
  },
  methods: {
    colorSeverity: function colorSeverity(color, value) {
      console.log(__WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(color, value / 100));
      return __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(color, value / 100);
    },
    loadServers: function loadServers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('servers', {
        params: {
          page: 0,
          rowsPerPage: 1000
        }
      }).then(function (response) {
        _this.servers = response.data.list;
        _this.serversMap = [];
        for (var i in _this.servers) {
          var server = _this.servers[i];
          server.visible = true;
        }
      });
    },
    fullScreen: function fullScreen() {
      this.$refs.container.webkitRequestFullscreen();
    }
  },
  created: function created() {
    this.loadServers();
    this.chartConfigs.push({
      id: 1,
      name: 'CPU Trend',
      type: 'cpu',
      serverIds: ['652569b93f28567d407d480c']
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.refreshInterval);
  }
});

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_ColorService__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DoughnutChart_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DoughnutChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DoughnutChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BarChart_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BarChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BarChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LineChart_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CollapsibleCard_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CollapsibleCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_CollapsibleCard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_2__components_DoughnutChart_vue___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_3__components_BarChart_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_4__components_LineChart_vue___default.a,
    CollapsibleCard: __WEBPACK_IMPORTED_MODULE_5__components_CollapsibleCard_vue___default.a
  },
  name: 'dashboard',
  data: function data() {
    return {
      servers: null,
      serversMap: null,
      group: '',
      groupOptions: null,
      metrics: null,
      displayMode: 'bar',
      displayModeOptions: [{ text: 'Text', value: 'text' }, { text: 'Bar', value: 'bar' }],
      refreshInterval: null,
      cpu: {
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#9fcdff',
              borderColor: '#9fcdff',
              data: []
            }, {
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      },
      memory: {
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      },
      swap: {
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      },
      disks: {
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        },
        activity: {
          chartData: {
            labels: [],
            datasets: []
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  suggestedMin: -5242880,
                  suggestedMax: 5242880,
                  callback: function callback(value, index, values) {
                    var max = Math.abs(value);
                    var divisor = 1;
                    var suffix = '';
                    if (max > 1048576) {
                      divisor = 1048576;
                      suffix = ' mb';
                    } else if (max > 1024) {
                      divisor = 1024;
                      suffix = ' kb';
                    }
                    return (Math.abs(value) / divisor).toFixed(2) + suffix;
                  }
                },
                scaleLabel: {
                  display: true,
                  labelString: ''
                }
              }]
            }
          }
        }
      },
      network: {
        chartData: {
          labels: [],
          datasets: [{
            label: 'Received',
            fill: true,
            backgroundColor: '#9fcdff',
            borderColor: '#9fcdff',
            data: []
          }, {
            label: 'Sent',
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                suggestedMin: -1048576,
                suggestedMax: 1048576,
                callback: function callback(value, index, values) {
                  var max = Math.abs(value);
                  var divisor = 1;
                  var suffix = '';
                  if (max > 1048576) {
                    divisor = 1048576;
                    suffix = ' mb';
                  } else if (max > 1024) {
                    divisor = 1024;
                    suffix = ' kb';
                  }
                  return (Math.abs(value) / divisor).toFixed(2) + suffix;
                }
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }]
          }
        }
      }
    };
  },
  methods: {
    colorSeverity: function colorSeverity(color, value) {
      console.log(__WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(color, value / 100));
      return __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(color, value / 100);
    },
    loadGroups: function loadGroups() {
      this.groupOptions = [];
      this.groupOptions.push({
        value: '',
        text: 'All'
      });
      for (var i in this.servers) {
        var server = this.servers[i];
        var indexOf = this.groupOptions.map(function (element) {
          return element.text;
        }).indexOf(server.group);
        if (indexOf < 0) {
          var option = {
            value: server.group,
            text: server.group
          };
          this.groupOptions.push(option);
        }
      }
    },
    loadServers: function loadServers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('servers', {
        params: {
          page: 0,
          rowsPerPage: 1000
        }
      }).then(function (response) {
        _this.servers = response.data.list;
        _this.serversMap = [];
        for (var i in _this.servers) {
          var server = _this.servers[i];
          server.visible = true;
          _this.serversMap[server.id] = server;
        }
        console.log(_this.serversMap);
        if (_this.groupOptions === null) {
          _this.loadGroups();
        }
      });
    },
    setVisible: function setVisible(server, visible) {
      this.serversMap[server.id].visible = visible;
    },
    isMatchGroup: function isMatchGroup(serverParam) {
      if (this.group === '') {
        return true;
      }
      if (this.group === serverParam.group) {
        return true;
      }
      return false;
    },
    isVisible: function isVisible(serverParam) {
      var server = this.serversMap[serverParam.id];
      if (server === undefined || server === null) {
        return false;
      }
      return server.visible;
    },
    isServerRendered: function isServerRendered(serverParam) {
      if (this.group !== '') {
        if (this.group !== serverParam.group) {
          return false;
        }
      }
      var server = this.serversMap[serverParam.id];
      if (server === undefined || server === null) {
        return false;
      }
      return server.visible;
    },
    updateData: function updateData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('dashboard').then(function (response) {
        _this2.metrics = response.data;
        _this2.cpu.trend.chartData.datasets = [];
        _this2.memory.trend.chartData.datasets = [];
        _this2.swap.trend.chartData.datasets = [];
        _this2.disks.activity.chartData.datasets = [];
        _this2.network.chartData.datasets = [];
        for (var i in _this2.metrics) {
          var server = _this2.metrics[i];
          if (_this2.isServerRendered(server.server) === false) {
            continue;
          }
          var labels = [];
          var cpuUsageTrend = [];
          var memoryUsageTrend = [];
          var swapUsageTrend = [];
          var diskUsageTrend = [];
          var diskReadsTrend = [];
          var diskWritesTrend = [];
          var networkReadsTrend = [];
          var networkWritesTrend = [];
          for (var j in server.metrics) {
            var metric = server.metrics[j];
            labels.push('');
            cpuUsageTrend.push(metric.cpu.usage);
            memoryUsageTrend.push(metric.memory.usage);
            swapUsageTrend.push(metric.swap.usage);
            diskUsageTrend.push(metric.disk.usage);
            diskReadsTrend.push(metric.disk.reads);
            diskWritesTrend.push(-metric.disk.writes);
            networkReadsTrend.push(metric.network.receivedBytes);
            networkWritesTrend.push(-metric.network.sentBytes);
          }
          var dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: cpuUsageTrend
            // update cpu trend data
          };_this2.cpu.trend.chartData.labels = labels;
          _this2.cpu.trend.chartData.datasets.push(dataset);

          // update memory trend data
          dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: memoryUsageTrend
          };
          _this2.memory.trend.chartData.labels = labels;
          _this2.memory.trend.chartData.datasets.push(dataset);

          // update swap trend data
          _this2.swap.trend.chartData.labels = labels;
          dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: swapUsageTrend

            // update disk trend chart data
            // this.disks.trend.chartData.labels = labels
            // this.disks.trend.chartData.datasets[0].data = diskUsageTrend

            // update disk activity trend chart data
          };_this2.disks.activity.chartData.labels = labels;
          dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: diskReadsTrend
          };
          _this2.disks.activity.chartData.datasets.push(dataset);
          dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: diskWritesTrend
          };
          _this2.disks.activity.chartData.datasets.push(dataset);

          // update network trend chart data
          _this2.network.chartData.labels = labels;
          dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: networkReadsTrend
          };
          _this2.network.chartData.datasets.push(dataset);
          dataset = {
            fill: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__services_ColorService__["a" /* colorService */].colorHexToRGBA(server.server.color, 0.5),
            borderColor: server.server.color,
            borderWidth: 1,
            pointRadius: 1,
            data: networkWritesTrend
          };
          _this2.network.chartData.datasets.push(dataset);
        }
        _this2.$refs.cpuTrendChart.updateChart();
        _this2.$refs.memoryTrendChart.updateChart();
        _this2.$refs.swapTrendChart.updateChart();
        _this2.$refs.disksActivityTrendChart.updateChart();
        _this2.$refs.networkTrendChart.updateChart();
      });
    },
    viewServerDashboard: function viewServerDashboard(serverId) {
      this.$router.push({
        name: 'ServerDashboardPage',
        params: {
          serverId: serverId
        }
      });
    },
    fullScreen: function fullScreen() {
      this.$refs.container.webkitRequestFullscreen();
    }
  },
  created: function created() {
    this.loadServers();
    this.updateData();
    this.refreshInterval = setInterval(this.updateData, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.refreshInterval);
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DoughnutChart_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DoughnutChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DoughnutChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BarChart_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BarChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_BarChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LineChart_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CollapsibleCard_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CollapsibleCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CollapsibleCard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DoughnutChart: __WEBPACK_IMPORTED_MODULE_1__components_DoughnutChart_vue___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_2__components_BarChart_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_3__components_LineChart_vue___default.a,
    CollapsibleCard: __WEBPACK_IMPORTED_MODULE_4__components_CollapsibleCard_vue___default.a
  },
  name: 'monitor',
  data: function data() {
    return {
      metrics: null,
      refreshInterval: null,
      summary: {
        chartData: {
          labels: ['CPU', 'Memory', 'Swap', 'Disk'],
          datasets: [{
            backgroundColor: ['#9fcdff', '#f1b0b7', '#b1dfbb', '#ffe8a1'],
            borderColor: ['#9fcdff', '#f1b0b7', '#b1dfbb', '#ffe8a1'],
            data: [0, 0, 0, 0]
          }]
        },
        chartOptions: {
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      },
      cpu: {
        pie: {
          chartData: {
            text: '123',
            labels: ['User', 'System', 'Idle'],
            datasets: [{
              backgroundColor: ['#9fcdff', '#f1b0b7', '#EEEEEE'],
              borderColor: ['#9fcdff', '#f1b0b7', '#EEEEEE'],
              data: [0, 0, 100]
            }]
          },
          chartOptions: {}
        },
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#9fcdff',
              borderColor: '#9fcdff',
              data: []
            }, {
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      },
      memory: {
        pie: {
          chartData: {
            labels: ['Used', 'Free'],
            datasets: [{
              backgroundColor: ['#f1b0b7', '#EEEEEE'],
              borderColor: ['#f1b0b7', '#EEEEEE'],
              data: [0, 100]
            }]
          },
          chartOptions: {}
        },
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      },
      swap: {
        pie: {
          chartData: {
            labels: ['Used', 'Free'],
            datasets: [{
              backgroundColor: ['#f1b0b7', '#EEEEEE'],
              borderColor: ['#f1b0b7', '#EEEEEE'],
              data: [0, 100]
            }]
          },
          chartOptions: {}
        },
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        }
      },
      disks: {
        pie: {
          chartData: {
            labels: ['Used', 'Free'],
            datasets: [{
              backgroundColor: ['#f1b0b7', '#EEEEEE'],
              borderColor: ['#f1b0b7', '#EEEEEE'],
              data: [0, 100]
            }]
          },
          chartOptions: {}
        },
        trend: {
          chartData: {
            labels: [],
            datasets: [{
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: false
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  max: 100
                }
              }]
            }
          }
        },
        activity: {
          chartData: {
            labels: [],
            datasets: [{
              label: 'Reads',
              fill: true,
              backgroundColor: '#9fcdff',
              borderColor: '#9fcdff',
              data: []
            }, {
              label: 'Writes',
              fill: true,
              backgroundColor: '#f1b0b7',
              borderColor: '#f1b0b7',
              data: []
            }]
          },
          chartOptions: {
            animation: {
              duration: 0
            },
            legend: {
              display: true
            },
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  suggestedMin: -5242880,
                  suggestedMax: 5242880,
                  callback: function callback(value, index, values) {
                    var max = Math.abs(value);
                    var divisor = 1;
                    var suffix = '';
                    if (max > 1048576) {
                      divisor = 1048576;
                      suffix = ' mb';
                    } else if (max > 1024) {
                      divisor = 1024;
                      suffix = ' kb';
                    }
                    return (Math.abs(value) / divisor).toFixed(2) + suffix;
                  }
                },
                scaleLabel: {
                  display: true,
                  labelString: ''
                }
              }]
            }
          }
        }
      },
      network: {
        chartData: {
          labels: [],
          datasets: [{
            label: 'Received',
            fill: true,
            backgroundColor: '#9fcdff',
            borderColor: '#9fcdff',
            data: []
          }, {
            label: 'Sent',
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: true
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                suggestedMin: -1048576,
                suggestedMax: 1048576,
                callback: function callback(value, index, values) {
                  var max = Math.abs(value);
                  var divisor = 1;
                  var suffix = '';
                  if (max > 1048576) {
                    divisor = 1048576;
                    suffix = ' mb';
                  } else if (max > 1024) {
                    divisor = 1024;
                    suffix = ' kb';
                  }
                  return (Math.abs(value) / divisor).toFixed(2) + suffix;
                }
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }]
          }
        }
      }
    };
  },
  methods: {
    updateData: function updateData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('dashboard/' + this.$route.params.serverId).then(function (response) {
        _this.metrics = response.data;
        // Update the summary chart data
        _this.summary.chartData.datasets[0].data[0] = _this.metrics.current.cpu.usage;
        _this.summary.chartData.datasets[0].data[1] = _this.metrics.current.memory.usage;
        _this.summary.chartData.datasets[0].data[2] = _this.metrics.current.swap.usage;
        _this.summary.chartData.datasets[0].data[3] = _this.metrics.current.disk.usage;
        // this.summary.chart.updateChart()
        _this.$refs.summaryChart.updateChart();

        var labels = [];
        var cpuUserTrend = [];
        var cpuSystemTrend = [];
        var memoryUsageTrend = [];
        var swapUsageTrend = [];
        var diskUsageTrend = [];
        var diskReadsTrend = [];
        var diskWritesTrend = [];
        var networkReadsTrend = [];
        var networkWritesTrend = [];
        for (var i in _this.metrics.metrics) {
          labels.push('');
          cpuUserTrend.push(_this.metrics.metrics[i].cpu.user);
          cpuSystemTrend.push(_this.metrics.metrics[i].cpu.system + _this.metrics.metrics[i].cpu.user);
          memoryUsageTrend.push(_this.metrics.metrics[i].memory.usage);
          swapUsageTrend.push(_this.metrics.metrics[i].swap.usage);
          diskUsageTrend.push(_this.metrics.metrics[i].disk.usage);
          diskReadsTrend.push(_this.metrics.metrics[i].disk.reads);
          diskWritesTrend.push(-_this.metrics.metrics[i].disk.writes);
          networkReadsTrend.push(_this.metrics.metrics[i].network.receivedBytes);
          networkWritesTrend.push(-_this.metrics.metrics[i].network.sentBytes);
        }
        // update cpu pie chart data
        _this.cpu.pie.chartData.text = _this.$filters.percentage(_this.metrics.current.cpu.usage);
        _this.cpu.pie.chartData.datasets[0].data[0] = _this.metrics.current.cpu.user;
        _this.cpu.pie.chartData.datasets[0].data[1] = _this.metrics.current.cpu.system;
        _this.cpu.pie.chartData.datasets[0].data[2] = _this.metrics.current.cpu.idle;
        _this.$refs.cpuPieChart.updateChart();

        // update cpu trend data
        _this.cpu.trend.chartData.labels = labels;
        _this.cpu.trend.chartData.datasets[0].data = cpuUserTrend;
        _this.cpu.trend.chartData.datasets[1].data = cpuSystemTrend;
        _this.$refs.cpuTrendChart.updateChart();

        // update memory pie chart data
        _this.memory.pie.chartData.text = _this.$filters.percentage(_this.metrics.current.memory.usage);
        _this.memory.pie.chartData.datasets[0].data[0] = _this.metrics.current.memory.used;
        _this.memory.pie.chartData.datasets[0].data[1] = _this.metrics.current.memory.free;
        _this.$refs.memoryPieChart.updateChart();

        // update memory trend data
        _this.memory.trend.chartData.labels = labels;
        _this.memory.trend.chartData.datasets[0].data = memoryUsageTrend;
        _this.$refs.memoryTrendChart.updateChart();

        // update swap pie chart data
        _this.swap.pie.chartData.text = _this.$filters.percentage(_this.metrics.current.swap.usage);
        _this.swap.pie.chartData.datasets[0].data[0] = _this.metrics.current.swap.used;
        _this.swap.pie.chartData.datasets[0].data[1] = _this.metrics.current.swap.free;
        _this.$refs.swapPieChart.updateChart();

        // update swap trend data
        _this.swap.trend.chartData.labels = labels;
        _this.swap.trend.chartData.datasets[0].data = swapUsageTrend;
        _this.$refs.swapTrendChart.updateChart();

        // update disk pie chart data
        _this.disks.pie.chartData.text = _this.$filters.percentage(_this.metrics.current.disk.usage);
        _this.disks.pie.chartData.datasets[0].data[0] = _this.metrics.current.disk.used;
        _this.disks.pie.chartData.datasets[0].data[1] = _this.metrics.current.disk.free;
        _this.$refs.disksPieChart.updateChart();

        // update disk trend chart data
        _this.disks.trend.chartData.labels = labels;
        _this.disks.trend.chartData.datasets[0].data = diskUsageTrend;
        _this.$refs.disksTrendChart.updateChart();

        // update disk activity trend chart data
        _this.disks.activity.chartData.labels = labels;
        _this.disks.activity.chartData.datasets[0].data = diskReadsTrend;
        _this.disks.activity.chartData.datasets[1].data = diskWritesTrend;
        _this.$refs.disksActivityTrendChart.updateChart();

        // update network trend chart data
        _this.network.chartData.labels = labels;
        _this.network.chartData.datasets[0].data = networkReadsTrend;
        _this.network.chartData.datasets[1].data = networkWritesTrend;
        _this.$refs.networkTrendChart.updateChart();
      });
    }
  },
  created: function created() {
    this.updateData();
    this.refreshInterval = setInterval(this.updateData, 1000);
  },
  destroyed: function destroyed() {
    console.log('destroyed');
    clearInterval(this.refreshInterval);
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_AuthenticationService__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangePassword',
  data: function data() {
    return {
      oldPassword: null,
      newPassword: null,
      verifyPassword: null
    };
  },
  methods: {
    changePassword: function changePassword(event) {
      var _this = this;

      event.preventDefault();
      var formData = new FormData();
      formData.append('oldPassword', this.oldPassword);
      formData.append('newPassword', this.newPassword);
      formData.append('verifyPassword', this.verifyPassword);
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('security/password', formData).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__services_AuthenticationService__["a" /* authenticationService */].updateCredential(_this.newPassword);
        _this.$swal({
          icon: 'success',
          title: 'Success',
          text: 'Your password has been successfully changed'
        }).then(function (response) {
          _this.$router.push({
            name: 'DashboardPage'
          });
        });
      }).catch(function (e) {
        _this.$swal({
          icon: 'error',
          title: 'Failed',
          text: 'An error occurred updating your password.'
        });
      });
    },
    cancel: function cancel() {
      this.$router.push({
        name: 'HomePage'
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      username: '',
      password: '',
      error: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      if (this.username === '' || this.password === '') {
        this.error = 'Username and password is required!';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__["a" /* authenticationService */].authenticate(this.username, this.password).then(function (data) {
        console.log('authentication successful');
        _this.$router.push('/dashboard');
      }).catch(function (e) {
        console.log('authentication error');
        _this.error = 'Invalid credentials, please try again';
        _this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Invalid credentials, please verify your username and password is correct'
        });
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'server',
  data: function data() {
    return {
      server: {
        name: null,
        hostname: null,
        port: 4444,
        color: null,
        group: null,
        description: null
      }
    };
  },
  methods: {
    addServer: function addServer(event) {
      var _this = this;

      event.preventDefault();
      var formData = new FormData();
      formData.append('name', this.server.name);
      formData.append('hostname', this.server.hostname);
      formData.append('port', this.server.port);
      formData.append('color', this.server.color);
      formData.append('group', this.server.group);
      formData.append('description', this.server.description);
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers', formData).then(function (response) {
        _this.$router.push({
          name: 'ServersPage'
        });
      });
    },
    cancel: function cancel() {
      this.$router.push({
        name: 'ServersPage'
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'server',
  data: function data() {
    return {
      server: null
    };
  },
  methods: {
    loadServer: function loadServer() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('servers/' + this.$route.params.serverId).then(function (response) {
        _this.server = response.data;
      });
    },
    updateServer: function updateServer() {
      var _this2 = this;

      var formData = new FormData();
      formData.append('name', this.server.name);
      formData.append('hostname', this.server.hostname);
      formData.append('port', this.server.port);
      formData.append('color', this.server.color);
      formData.append('group', this.server.group);
      formData.append('description', this.server.description);
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].put('servers/' + this.$route.params.serverId, formData).then(function (response) {
        _this2.$router.push({
          name: 'ServersPage'
        });
      });
    },
    cancel: function cancel() {
      this.$router.push({
        name: 'ServersPage'
      });
    }
  },
  created: function created() {
    this.loadServer();
  }
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(30);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'servers',
  data: function data() {
    return {
      displayMode: 'table',
      displayModeOptions: [{ text: 'List', value: 'list' }, { text: 'Table', value: 'table' }],
      items: [],
      pageNo: 1,
      rowsPerPage: 10,
      totalItems: 0,
      filter: null
    };
  },
  methods: {
    pageChange: function pageChange() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('servers', {
        params: {
          page: this.pageNo - 1,
          rowsPerPage: this.rowsPerPage,
          search: this.filter
        }
      }).then(function (response) {
        _this.items = response.data.list;
        _this.rowsPerPage = response.data.rowsPerPage;
        _this.totalItems = response.data.totalItems;
      });
    },
    refreshServer: function refreshServer(serverId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers/' + serverId + '/refresh').then(function (response) {
        _this2.pageChange();
      });
    },
    deleteServer: function deleteServer(serverId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].delete('servers/' + serverId).then(function (response) {
        _this3.pageChange();
      });
    },
    startMonitor: function startMonitor(serverId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers/' + serverId + '/agent/start').then(function (response) {
        _this4.pageChange();
      });
    },
    stopMonitor: function stopMonitor(serverId) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers/' + serverId + '/agent/stop').then(function (response) {
        _this5.pageChange();
      });
    },
    setEnable: function setEnable(serverId, status) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers/' + serverId + '/enable?enable=' + status).then(function (response) {
        _this6.pageChange();
      });
    },
    setVisible: function setVisible(serverId, visible) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('servers/' + serverId + '/visible?visible=' + visible).then(function (response) {
        _this7.pageChange();
      });
    },
    viewServer: function viewServer(serverId) {
      this.$router.push({
        name: 'ServerDetailsPage',
        params: {
          serverId: serverId
        }
      });
    }
  },
  created: function created() {
    this.pageChange();
  }
});

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_HttpService__ = __webpack_require__(30);





// import router from '../router'

/**
 * AuthenticationService takes care of authenticating the user and maintaining the state the user
 * This uses the local storage for persisting the user to be able to survive page refresh.
 *
 * This also maintains a user member field to make it reactive.
 *
 * Provides isAuthenticated, getUser, authenticate and logout methods
 * This is a singleton object, created only once when the application is loaded
 */

var AuthenticationService = function () {
  /**
   * Constructor - initializes the AuthorizationService.
   *
   * This will check the local storage if a user exists.
   * If the user exists, it loads it and sets the user member field
   * This also loads the stored credentials and sets the HTTP Authorization headers globally
   * so succeeding calls do not need to set it manually
   */
  function AuthenticationService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AuthenticationService);

    // console.log('AuthenticationService() - constructor')
    this.user = null;
    // we check if the local storage contains a user
    var userJson = sessionStorage.getItem('user');
    if (userJson != null) {
      // console.log('AuthenticationService() - user found in sessionStorage =>' + userJson)
      this.user = JSON.parse(userJson);
      // console.log('AuthenticationService() - loading user credentials from storage')
      var credentials = JSON.parse(sessionStorage.getItem('credentials'));
      // console.log('AuthenticationService() - setting http authorization headers')
      __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = 'Basic ' + credentials;
    }
  }
  /**
   * This returns true if a user has authenticated
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AuthenticationService, [{
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      // console.log('AuthenticationService.isAuthenticated() => ' + (this.user != null))
      if (this.user == null) {
        return false;
      }
      return true;
    }
    /**
     * Get the current active user if available
     */

  }, {
    key: 'getUser',
    value: function getUser() {
      return this.user;
    }
    /**
     * Update the current user data
     */

  }, {
    key: 'setUser',
    value: function setUser(user) {
      this.user = user;
      sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.user));
    }
    /**
     * Authenticate a user given the username and password.
     * If authentication is successful, the following actions are performed
     * 1.) Update the user member field so VueJS will be notified
     * 2.) Store the user to the local storage so we can survive a page refresh
     * 3.) Store the credentials to the local storage so we can set the authentication headers when the page is reloaded
     * 4.) Set the http authorization headers
     *
     * If the authorization fails, it throws an exception
     */

  }, {
    key: 'authenticate',
    value: function authenticate(username, password) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // console.log('AuthenticationService.authenticate()')
        var credentials = btoa(username + ':' + password);
        // console.log('AuthenticationService.authenticate() - Credentials = ' + credentials)
        __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].post('security/login', {}, {
          headers: {
            Authorization: 'Basic ' + credentials
          }
        }).then(function (response) {
          // console.log('AuthenticationService.authenticate() - authenticated successfully')
          _this.user = response.data;
          // store to local storage
          // console.log('AuthenticationService.authenticate() - storing user to sessionStorage')
          sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.user));
          // console.log('AuthenticationService.authenticate() - setting http authorization headers')
          __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = 'Basic ' + credentials;
          sessionStorage.setItem('credentials', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(credentials));
          resolve(_this.user);
        }).catch(function (e) {
          console.log('AuthenticationService.error=>' + e);
          reject(e);
        });
      });
    }

    /**
     * This method will logout the logged-in user
     * This following actions is performed
     * 1.) Set the user member to null to notify VueJS that the user is logged out
     * 2.) Remove the user from the local storage
     * 3.) Remove the credentials from the local storage
     */

  }, {
    key: 'logout',
    value: function logout() {
      // console.log('AuthenticationService.logout()')
      this.user = null;
      // console.log('AuthenticationService.logout() - removing user from sessionStorage')
      sessionStorage.removeItem('user', null);
      // console.log('AuthenticationService.authenticate() - removing http authorization headers')
      __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = null;
      sessionStorage.removeItem('credentials');
    }
  }, {
    key: 'updateCredential',
    value: function updateCredential(password) {
      var credentials = btoa(this.user.username + ':' + password);
      __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = 'Basic ' + credentials;
      sessionStorage.setItem('credentials', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(credentials));
    }
    /**
     * Check if the logged-in user has the given authority. If user is not logged-in it returns false
     */

  }, {
    key: 'hasAuthority',
    value: function hasAuthority(authority) {
      if (this.user == null) {
        return false;
      }
      for (var i = 0; i < this.user.authorities.length; i++) {
        var thisAuthority = this.user.authorities[i];
        if (thisAuthority === authority) {
          return true;
        }
      }
      return false;
    }
  }]);

  return AuthenticationService;
}();

var authenticationService = new AuthenticationService();

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 316,
	"./af.js": 316,
	"./ar": 323,
	"./ar-dz": 317,
	"./ar-dz.js": 317,
	"./ar-kw": 318,
	"./ar-kw.js": 318,
	"./ar-ly": 319,
	"./ar-ly.js": 319,
	"./ar-ma": 320,
	"./ar-ma.js": 320,
	"./ar-sa": 321,
	"./ar-sa.js": 321,
	"./ar-tn": 322,
	"./ar-tn.js": 322,
	"./ar.js": 323,
	"./az": 324,
	"./az.js": 324,
	"./be": 325,
	"./be.js": 325,
	"./bg": 326,
	"./bg.js": 326,
	"./bm": 327,
	"./bm.js": 327,
	"./bn": 328,
	"./bn.js": 328,
	"./bo": 329,
	"./bo.js": 329,
	"./br": 330,
	"./br.js": 330,
	"./bs": 331,
	"./bs.js": 331,
	"./ca": 332,
	"./ca.js": 332,
	"./cs": 333,
	"./cs.js": 333,
	"./cv": 334,
	"./cv.js": 334,
	"./cy": 335,
	"./cy.js": 335,
	"./da": 336,
	"./da.js": 336,
	"./de": 339,
	"./de-at": 337,
	"./de-at.js": 337,
	"./de-ch": 338,
	"./de-ch.js": 338,
	"./de.js": 339,
	"./dv": 340,
	"./dv.js": 340,
	"./el": 341,
	"./el.js": 341,
	"./en-SG": 342,
	"./en-SG.js": 342,
	"./en-au": 343,
	"./en-au.js": 343,
	"./en-ca": 344,
	"./en-ca.js": 344,
	"./en-gb": 345,
	"./en-gb.js": 345,
	"./en-ie": 346,
	"./en-ie.js": 346,
	"./en-il": 347,
	"./en-il.js": 347,
	"./en-nz": 348,
	"./en-nz.js": 348,
	"./eo": 349,
	"./eo.js": 349,
	"./es": 352,
	"./es-do": 350,
	"./es-do.js": 350,
	"./es-us": 351,
	"./es-us.js": 351,
	"./es.js": 352,
	"./et": 353,
	"./et.js": 353,
	"./eu": 354,
	"./eu.js": 354,
	"./fa": 355,
	"./fa.js": 355,
	"./fi": 356,
	"./fi.js": 356,
	"./fo": 357,
	"./fo.js": 357,
	"./fr": 360,
	"./fr-ca": 358,
	"./fr-ca.js": 358,
	"./fr-ch": 359,
	"./fr-ch.js": 359,
	"./fr.js": 360,
	"./fy": 361,
	"./fy.js": 361,
	"./ga": 362,
	"./ga.js": 362,
	"./gd": 363,
	"./gd.js": 363,
	"./gl": 364,
	"./gl.js": 364,
	"./gom-latn": 365,
	"./gom-latn.js": 365,
	"./gu": 366,
	"./gu.js": 366,
	"./he": 367,
	"./he.js": 367,
	"./hi": 368,
	"./hi.js": 368,
	"./hr": 369,
	"./hr.js": 369,
	"./hu": 370,
	"./hu.js": 370,
	"./hy-am": 371,
	"./hy-am.js": 371,
	"./id": 372,
	"./id.js": 372,
	"./is": 373,
	"./is.js": 373,
	"./it": 375,
	"./it-ch": 374,
	"./it-ch.js": 374,
	"./it.js": 375,
	"./ja": 376,
	"./ja.js": 376,
	"./jv": 377,
	"./jv.js": 377,
	"./ka": 378,
	"./ka.js": 378,
	"./kk": 379,
	"./kk.js": 379,
	"./km": 380,
	"./km.js": 380,
	"./kn": 381,
	"./kn.js": 381,
	"./ko": 382,
	"./ko.js": 382,
	"./ku": 383,
	"./ku.js": 383,
	"./ky": 384,
	"./ky.js": 384,
	"./lb": 385,
	"./lb.js": 385,
	"./lo": 386,
	"./lo.js": 386,
	"./lt": 387,
	"./lt.js": 387,
	"./lv": 388,
	"./lv.js": 388,
	"./me": 389,
	"./me.js": 389,
	"./mi": 390,
	"./mi.js": 390,
	"./mk": 391,
	"./mk.js": 391,
	"./ml": 392,
	"./ml.js": 392,
	"./mn": 393,
	"./mn.js": 393,
	"./mr": 394,
	"./mr.js": 394,
	"./ms": 396,
	"./ms-my": 395,
	"./ms-my.js": 395,
	"./ms.js": 396,
	"./mt": 397,
	"./mt.js": 397,
	"./my": 398,
	"./my.js": 398,
	"./nb": 399,
	"./nb.js": 399,
	"./ne": 400,
	"./ne.js": 400,
	"./nl": 402,
	"./nl-be": 401,
	"./nl-be.js": 401,
	"./nl.js": 402,
	"./nn": 403,
	"./nn.js": 403,
	"./pa-in": 404,
	"./pa-in.js": 404,
	"./pl": 405,
	"./pl.js": 405,
	"./pt": 407,
	"./pt-br": 406,
	"./pt-br.js": 406,
	"./pt.js": 407,
	"./ro": 408,
	"./ro.js": 408,
	"./ru": 409,
	"./ru.js": 409,
	"./sd": 410,
	"./sd.js": 410,
	"./se": 411,
	"./se.js": 411,
	"./si": 412,
	"./si.js": 412,
	"./sk": 413,
	"./sk.js": 413,
	"./sl": 414,
	"./sl.js": 414,
	"./sq": 415,
	"./sq.js": 415,
	"./sr": 417,
	"./sr-cyrl": 416,
	"./sr-cyrl.js": 416,
	"./sr.js": 417,
	"./ss": 418,
	"./ss.js": 418,
	"./sv": 419,
	"./sv.js": 419,
	"./sw": 420,
	"./sw.js": 420,
	"./ta": 421,
	"./ta.js": 421,
	"./te": 422,
	"./te.js": 422,
	"./tet": 423,
	"./tet.js": 423,
	"./tg": 424,
	"./tg.js": 424,
	"./th": 425,
	"./th.js": 425,
	"./tl-ph": 426,
	"./tl-ph.js": 426,
	"./tlh": 427,
	"./tlh.js": 427,
	"./tr": 428,
	"./tr.js": 428,
	"./tzl": 429,
	"./tzl.js": 429,
	"./tzm": 431,
	"./tzm-latn": 430,
	"./tzm-latn.js": 430,
	"./tzm.js": 431,
	"./ug-cn": 432,
	"./ug-cn.js": 432,
	"./uk": 433,
	"./uk.js": 433,
	"./ur": 434,
	"./ur.js": 434,
	"./uz": 436,
	"./uz-latn": 435,
	"./uz-latn.js": 435,
	"./uz.js": 436,
	"./vi": 437,
	"./vi.js": 437,
	"./x-pseudo": 438,
	"./x-pseudo.js": 438,
	"./yo": 439,
	"./yo.js": 439,
	"./zh-cn": 440,
	"./zh-cn.js": 440,
	"./zh-hk": 441,
	"./zh-hk.js": 441,
	"./zh-tw": 442,
	"./zh-tw.js": 442
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 584;

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.e264b38.png";

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(2147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(479),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colorService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Color Server
 */
var ColorService = function () {
  function ColorService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ColorService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ColorService, [{
    key: 'colorHexToRGBA',

    /**
     * Convert a color hex to a rgba color
     */
    value: function colorHexToRGBA(hex, opacity) {
      hex = hex.replace('#', '');
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    }
  }]);

  return ColorService;
}();

var colorService = new ColorService();

/***/ })

},[473]);


// WEBPACK FOOTER //
// static/js/app.bd602f09ebdd08691333.js